import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Header from '../../components/Header';

const Incomplete = (props) => {
  const { checkinData, navigate, params, searchParams } = props;
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');

  useEffect(() => {
    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    }
  }, []);

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <div className="content">
        <h1>We were unable to complete your application at this time and need to verify some additional information</h1>
        <p>
          Please call
          {' '}
          <a href="tel:+18009446177">1-800-944-6177</a>
          {' '}
          now to speak with a LendingUSA Credit Specialist, or a member of our team will contact you in regards to your application within 24 hours.
        </p>
      </div>
      <div className="footer">
        <div className="row">
          <div className="col">
            <a href="mailto:support@lendingusa.com" className="btn">Contact Us</a>
          </div>
        </div>
      </div>
    </div>
  );
};

Incomplete.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(Incomplete);
